import React, { useState, useEffect, useRef } from "react";
import "./Calender.css";
import { multiCalendarPages } from "../../constant/calendarConfigs";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { Calendar, DateRangePicker } from "react-date-range";
import { addDays } from "date-fns";
import moment from "moment/moment";
import defaultDateRangesWithLables, {
  buildCompareRangesFromSelection,
  getDefaultCalendarDate,
  getDefaultDateRangesWithLabels,
} from "../../constant/calendarDefaultConfigurations";
import { useGlobalContext } from "../../context/global";
import { useLocation } from "react-router-dom";
import { calenderDate } from "../../components/Reports/Components/utils";
import { Box, Button, Typography, Switch } from "@mui/material";
import { toast } from "react-toastify";


const CalenderComponent = (props) => {
  const globalContext = useGlobalContext();
  const isLocalCalendar =
    Boolean(props?.localCalendar) && Boolean(props?.localCalendarState);

  const {
    calendarDate,
    setCalendarDate,
    dateDifference,
    setDateDifference,
    oldDateDifference,
    setOldDateDifference,
    oldCalendarData,
    setOldCalendarData,
    applyCalendar,
    setApplyCalendar,
  } = isLocalCalendar ? props.localCalendarState : globalContext;

  const {
    reportsTime,
    reportsFunnelType,
    calendarFreeze,
    setReportsFunnelType,
  } = globalContext;
  // A local calendar with its own compare ranges (Header's) compares without changing the global
  // ones; other local calendars (FilterDateInput) carry none and keep using the global ranges.
  const { multiCalendarDate, setMultiCalendarDate } =
    isLocalCalendar && props.localCalendarState.setMultiCalendarDate
      ? props.localCalendarState
      : globalContext;

  const [multiRange, setMultiRange] = useState(false)
  const location = useLocation();
  const pathName = location.pathname;
  const divRef = useRef(null);


  const includeToday = Boolean(props?.includeToday);
  const dateRangesWithLabels = includeToday
    ? getDefaultDateRangesWithLabels(true)
    : defaultDateRangesWithLables;

  const formatDateFn = (date) => {
    const selectedDate = new Date(date);
    return (
      selectedDate.getDate() +
      "-" +
      parseInt(selectedDate.getMonth() + 1) +
      "-" +
      selectedDate.getFullYear()
    );
  };

  useEffect(() => {
    // Local calendars must never mutate/read global date labels.
    if (isLocalCalendar) {
      setMultiRange(false);
      return;
    }
    if (!multiCalendarPages?.includes(pathName)) {
      setReportsFunnelType(null);
      setDateDifference(oldDateDifference);
      setMultiRange(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathName, isLocalCalendar]);

  useEffect(() => {
    if (props.multiRange) {
      setMultiRange(true);
    }
  }, [props.multiRange]);

  useEffect(() => {
    if (isLocalCalendar) return;
    if (reportsFunnelType !== undefined && reportsTime !== undefined) {
      if (reportsFunnelType === "Comparison View") {
        setMultiRange(true);
        setMultiCalendarDate({
          selection1: {
            startDate: calenderDate(reportsTime[0][0]),
            endDate: calenderDate(reportsTime[0][1]),
            key: "selection1",
          },
          selection2: {
            startDate: calenderDate(reportsTime[1][0]),
            endDate: calenderDate(reportsTime[1][1]),
            key: "selection2",
          },
        });
      } else {
        if (props.multiRange) {
          setMultiRange(true);
        } else {
          setMultiRange(false);
        }
        setCalendarDate([
          {
            startDate: calenderDate(reportsTime[0][0]),
            endDate: calenderDate(reportsTime[0][1]),
            key: "selection",
          },
        ]);
      }
    }
  }, [reportsTime, isLocalCalendar]);

  useEffect(() => {
    formatDateFn(calendarDate);
  }, [calendarDate]);

  const rangeHandler = () => {
    setCalendarDate(oldCalendarData);
    props.setShowCustomDateBox?.(false);
  };

  useEffect(() => {
    // Single-date popovers manage their own close (e.g. FilterDateInput ClickAwayListener).
    if (props.singleDatePicker) return;

    const handleOutsideClick = (event) => {
      if (
        divRef.current &&
        !divRef.current.contains(event.target) &&
        !event.target.closest(".calender-class")
      ) {
        rangeHandler();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [oldCalendarData, props.singleDatePicker]);

  const getSpecificDataFormat = (date) => {
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear().toString().slice(-2);
    return `${day} ${month} ${year}`;
  };

  const getSelectedPresetLabel = (range) => {
    for (let i = 0; i < dateRangesWithLabels.length; i++) {
      const staticRange = dateRangesWithLabels[i].range();
      if (
        moment(range.startDate).isSame(staticRange.startDate, "day") &&
        moment(range.endDate).isSame(staticRange.endDate, "day")
      ) {
        return { date: dateRangesWithLabels[i].label, isCustom: false };
      }
    }

    const formattedStartDate = getSpecificDataFormat(range.startDate);
    const formattedEndDate = getSpecificDataFormat(range.endDate);
     return {
      date: formattedStartDate !== formattedEndDate
        ? formattedStartDate + " - " + formattedEndDate
        : formattedStartDate,
      isCustom: true,
    };
  };

  const applyHandler = () => {
    if (multiRange) {
      setApplyCalendar(applyCalendar + 1);
      props.setShowCustomDateBox?.(false);
    } else {
      if (calendarDate !== oldCalendarData) {
        setOldDateDifference(dateDifference);
        setOldCalendarData(calendarDate);
        setApplyCalendar(applyCalendar + 1);
      }
      props.setShowCustomDateBox?.(false);
    }
  };

  const handleDateRangeChange = (range) => {
    const dateLabel = getSelectedPresetLabel(range.selection);
 window.sessionStorage.getItem('dateDiff',dateLabel)
    setDateDifference(dateLabel.date);
    setCalendarDate([range.selection]);

    if (!dateLabel.isCustom) {
      setOldDateDifference(dateLabel.date);
      setOldCalendarData([range.selection]);
      setApplyCalendar(applyCalendar + 1);
      props.setShowCustomDateBox?.(false);
    }
  };

  const onMultiRangeChange = (range) => {
    setDateDifference("Custom");
    window.sessionStorage.getItem('dateDiff',"Custom")
    setMultiCalendarDate({ ...multiCalendarDate, ...range });
  };

  // Amazon includes today. A stored Last 7 Days range still ending yesterday
  // should follow that preset through today.
  useEffect(() => {
    if (!includeToday || isLocalCalendar) return;
    if (dateDifference !== "Last 7 Days") return;
    const end = calendarDate?.[0]?.endDate;
    if (!end || !moment(end).isBefore(moment().startOf("day"))) return;
    const nextRange = getDefaultCalendarDate(true);
    setCalendarDate(nextRange);
    setOldCalendarData(nextRange);
    setApplyCalendar((prev) => prev + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [includeToday, isLocalCalendar]);

  // Stale sessionStorage multi-range defaults used to end on today even though
  // normal presets (Last 7 Days, etc.) exclude today. Correct those once on mount.
  useEffect(() => {
    if (isLocalCalendar || includeToday) return;
    const selection1End = multiCalendarDate?.selection1?.endDate;
    if (
      selection1End &&
      moment(selection1End).isSame(moment(), "day") &&
      calendarDate?.[0]?.startDate &&
      calendarDate?.[0]?.endDate
    ) {
      setMultiCalendarDate(buildCompareRangesFromSelection(calendarDate[0]));
      setApplyCalendar((prev) => prev + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleComparisonSwitch = (e) => {
    const checked = e.target.checked;
        // Prevent enabling comparison if hideComparisonSwitch prop is true
        if (checked && props?.hideComparisonSwitch) {
          toast.warning("Comparison view is not available when Analysis By is set to Date");
          return;
        }

    if (checked && calendarDate?.[0]?.startDate && calendarDate?.[0]?.endDate) {
      // Keep Period A aligned with the current single-range selection (e.g. Last 7 Days
      // ending yesterday) instead of the stale multi-range default that included today.
      setMultiCalendarDate(buildCompareRangesFromSelection(calendarDate[0]));
      setApplyCalendar(applyCalendar + 1);
    }
    
    setMultiRange(checked);
    const searchParams = new URLSearchParams(window.location.search);
    if (checked) {
      searchParams.set("isComparisonView", "true");
    } else {
      searchParams.delete("isComparisonView");
    }
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState({}, "", newUrl);
    if (props?.handleComparisonView) {
      props?.handleComparisonView(checked);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isComparisonEnabled = params.get("isComparisonView") === "true";
    // If comparison is enabled but hideComparisonSwitch is true, disable it
    if (isComparisonEnabled && props?.hideComparisonSwitch) {
      setMultiRange(false);
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.delete("isComparisonView");
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      window.history.replaceState({}, "", newUrl);
      if (props?.handleComparisonView) {
        props?.handleComparisonView(false);
      }
    } else {
      setMultiRange(isComparisonEnabled);
    }
  }, [props?.hideComparisonSwitch]);



 const maxDaysValue =
    props?.maxDays !== undefined
      ? props.maxDays
      : includeToday
        ? 0
        : -1;
 const singleDatePicker = {
    date:props.date,
    onChange:props.onSingleDateChange,
    maxDate: props.singlePickerMaxDate ?? addDays(new Date(), maxDaysValue),
  }
  const singlePickerMinDate =
    props.singlePickerMinDate ?? addDays(new Date(), 0);
  const classNameForCalendar = multiRange ? 'multicalendar-dates' : props?.className
  return (
    <>
      <div
        className={`calender-class ${
          calendarFreeze ? "disable-pointer-events" : ""
        }`}
        ref={divRef}
      >
        {props.singleDatePicker ? (
          <Calendar
            {...singleDatePicker}
            selectionType={"multiple"}
            showSelectionPreview={true}
            minDate={singlePickerMinDate}
            maxDate={singleDatePicker.maxDate}
          />
        ) : (
          <>
            {" "}
            <DateRangePicker
              ref={props.ref}
              className={classNameForCalendar}
              onChange={
                !multiRange ? handleDateRangeChange : onMultiRangeChange
              }
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              maxDate={addDays(new Date(), maxDaysValue)}
              key={reportsFunnelType} // Applying this key to remount the component if user has selected multirange previous range and switching back to normal calendar so focus should be on main range.
              ranges={
                multiRange
                  ? [multiCalendarDate.selection1, multiCalendarDate.selection2]
                  : calendarDate
              }
              direction="horizontal"
              calendarFocus="backwards"
              preventSnapRefocus={true}
              classNames={"multidate-range-dates"}
              // rangeColors={["rgba(255, 131, 100, 0.861)"]}
              rangeColors={multiRange ? ["#6148f6", "#29BFB2"] : ["#6148f6"]}
              // showDateDisplay={false}
              showMonthAndYearPickers={true}
              // hasCustomRendering={true}
              renderStaticRangeLabel={rangeHandler}
              staticRanges={dateRangesWithLabels}
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                px: 3, // horizontal footer padding
                py: 2, // vertical footer padding
                borderTop: "1px solid #E5E7EB", // subtle footer divider
              }}
            >
              {props?.handleComparisonView && !props?.hideComparisonSwitch && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mr: "auto",
                  }}
                >
                  <Switch
                    size="small"
                    checked={multiRange}
                    onChange={handleComparisonSwitch}
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#6148f6",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                        backgroundColor: "#6148f6",
                      },
                    }}
                  />
                  <Typography variant="body2">Compare data</Typography>
                </Box>
              )}

              <Button
                variant="outlined"
                onClick={rangeHandler}
                size="small"
                sx={{ marginRight: "10px" }}
              >
                Cancel
              </Button>

              <Button variant="contained" onClick={applyHandler} size="small">
                Apply
              </Button>
            </Box>
          </>
        )}
      </div>
    </>
  );
};
export default CalenderComponent;
